import { SvgIcon } from '@material-ui/core'

export const DotsIcon = props => (
  <SvgIcon {...props} style={{ fill: 'none' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M14 15.1667C14.6443 15.1667 15.1667 14.6443 15.1667 14C15.1667 13.3557 14.6443 12.8333 14 12.8333C13.3557 12.8333 12.8333 13.3557 12.8333 14C12.8333 14.6443 13.3557 15.1667 14 15.1667Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.1667 15.1667C22.811 15.1667 23.3333 14.6443 23.3333 14C23.3333 13.3557 22.811 12.8333 22.1667 12.8333C21.5223 12.8333 21 13.3557 21 14C21 14.6443 21.5223 15.1667 22.1667 15.1667Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.83333 15.1667C6.47767 15.1667 7 14.6443 7 14C7 13.3557 6.47767 12.8333 5.83333 12.8333C5.189 12.8333 4.66667 13.3557 4.66667 14C4.66667 14.6443 5.189 15.1667 5.83333 15.1667Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
)
